import { HStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

export const ShowColoredPrices = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = (): void => {
    sgwtWebAnalytics?.trackEvent(
      'Header',
      'user preferences, cash tab, show colored prices',
      String(!userPreferences.showColoredPrices),
    );

    updateUserPreferences({
      ...userPreferences,
      showColoredPrices: !userPreferences.showColoredPrices,
    });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="show-colored-prices">
        <FormattedMessage id="userPreferences.label.showColoredPrices" />
      </label>

      <HStack className="form-check-sm form-check-valid form-switch" data-e2e="showColoredPrices">
        <input
          id="show-colored-prices"
          className="form-check-input me-8px"
          type="checkbox"
          checked={userPreferences.showColoredPrices}
          onChange={handleChange}
          data-e2e={'showColoredPrices-checkbox'}
        />

        <span>
          <FormattedMessage id={`switchInput.${userPreferences.showColoredPrices ? 'on' : 'off'}`} />
        </span>
      </HStack>
    </div>
  );
};
